export default __webpack_public_path__ + "static/media/login-bg.1180fef7.png";